import locale from "common/managers/locale";
export default function(items, none, useOr) {
    var itemList = "";
    if (items.length > 0) {
        itemList = items[0];
    } else if (items.length == 0 && none) {
        itemList = locale.get(none);
    }
    var joiner = "join",
        joinTwo = useOr ? "joinTwoOr" : "joinTwo",
        joinLast = useOr ? "joinLastOr" : "joinLast";
    for (var i = 1; i < items.length; i++) {
        if (i == items.length - 1) {
            joiner = items.length == 2 ? joinTwo : joinLast;
        }
        itemList = locale.get(joiner, itemList, items[i]);
    }
    return itemList;
};